<template>
  <LibraryLayout :title="'Story Library'" :items="stories">
    <template slot="button">
      <v-btn v-if="authUser" @click="createStory" color="green" dark class="elevation-0">
        <v-icon left>mdi-creation-outline</v-icon> Create Story
      </v-btn>
      <v-btn v-else @click="go('LoginView')" color="green" dark class="elevation-0">
        <v-icon left>mdi-lock-outline</v-icon> Create Story
      </v-btn>
    </template>
    <template #card="{ item: story }">
      <v-card class="ma-2" width="300" @click="go('StoryPlayer', story.id)">
        <v-img :src="story.thumbnail" color="grey lighten-4" height="200"></v-img>
        <v-divider></v-divider>
        <div class="px-4 pt-4 cal-sans-regular font-size-20">{{ story.title || story.name }}</div>
        <div class="d-flex flex-row align-center px-4 pb-4 pt-2">
          <v-avatar size="30">
            <v-img src="@/assets/babyboomy.png"></v-img>
          </v-avatar>
          <p class="ma-0 ml-2">Baby Boomy</p>
        </div>
      </v-card>
    </template>
  </LibraryLayout>
</template>

<script>
import { getDocs, collection } from 'firebase/firestore'
import { db } from '@/firebase/init'
import LibraryLayout from '@/layouts/Library.vue'

export default {

  name: 'StoryLibrary',
  
  components: { LibraryLayout },

  data() {
    return {
      stories: [],
      progress: 0,
    }
  },

  created() {
    this.loadStories()
  },

  methods: {
    loadStories() {
      this.progress = 0
      const storiesRef = collection(db, 'stories')
      getDocs(storiesRef).then((snapshot) => {
        snapshot.forEach((doc) => {
          let story = doc.data()
          story.id = doc.id
          this.stories.push(story)
        })
        this.progress = 100
      })
    },

    async createStory() {
      if (this.authUser) {
        await this.$creator.create('story', this.profile);
      }
    }
  }
}
</script>

<style scoped>

</style>